import { render, staticRenderFns } from "./ModalUserTasks.vue?vue&type=template&id=7fa2382c&"
import script from "./ModalUserTasks.vue?vue&type=script&lang=ts&"
export * from "./ModalUserTasks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports